import React from "react";

export default function Footer(){
    return (
        <div className = "Footer">
        <a href="https://github.com/DianaRivero/react-weather-app" target = "_blank" rel="noopener noreferrer"
          >Open-source-code </a> 
        by Diana Rivero
        </div>
    )

}